module.exports = (Promise.resolve(__parcel__require__("./" + "Native.c8873ec0.661fbb85.js"))).then(() => parcelRequire('k5zDY'));